import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsMetersIP, MultiOptDetails_4DS, MultiOptDetails_6DS, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-meters',
  templateUrl: './ds-meters.component.html',
  styleUrls: ['./ds-meters.component.css']
})
export class DsMetersComponent implements OnInit, OnChanges {

  @Input() dsMetersObj: DsMetersIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsMetersObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewMultiFuncBlock() {
    this.dsMetersObj.addMutliFuncDS(new MultiOptDetails_6DS("", "", "", "", "", ""));
  }
  removeMultiFuncBlock(_mfDS: MultiOptDetails_6DS) {
    if (_mfDS) {
      this.dsMetersObj.removeMutliFuncDS(_mfDS);
    }
  }

  onMultiApplicabilityChange(_ty2): boolean {
    if(!_ty2 || _ty2 == "001") { // When type2 is 'Applicable'
      return true;
    }
    return false;
  }
  onMeterCommChange(_ty3, _opt): boolean {
    if(_opt == 1){ // Multi Function Meter}
    if(!_ty3 || _ty3 != "004") { // When type3 is not 'Non Communicable'
      return true;
    } 
    return false;
  }
  else if(_opt == 2){ // Tri Vector Meter
    if(!_ty3 || _ty3 != "005") { // When type3 is not 'Non Communicable'
      return true;
    } 
    return false;
  }
}

  addNewTriVectBlock() {
    this.dsMetersObj.addTriVectDS(new MultiOptDetails_6DS("", "", "", "", "", ""));
  }
  removeTriVectBlock(_tvDS: MultiOptDetails_6DS) {
    if (_tvDS) {
      this.dsMetersObj.removeTriVectDS(_tvDS);
    }
  }

  cachedAmmDisp: any = {};
  filterAmmDisp() {
    let _id = this.dsMetersObj.ammeterType;
    if (this.cachedAmmDisp[_id] != null) {
      return this.cachedAmmDisp[_id];
    }
    this.cachedAmmDisp[_id] = this._dataService.metAmmDisplay.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedAmmDisp[_id];
    if (this.cachedAmmDisp[_id] != null) {
      return this.cachedAmmDisp[_id];
    }
    var _result = !this._dataService.isGeneralMetAmmDisplay(_id);
    this.cachedAmmDisp[_id] = _result;
    return _result;
  }

  sectionNoteChangePM(_event: any) {
    this.dsMetersObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsMetersObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsMetersObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        // new ValidationItem("Ammeter Type", !!this.dsMetersObj.ammeterType, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsMetersObj.sectionNoteEE, " required to save Datasheet.")
      );
      // if (this.dsMetersObj.ammeterTypeApplicable) {
      //   _validList.push(new ValidationItem("Ammeter Display", !!this.dsMetersObj.ammeterDisplay, " required to save Datasheet."));
      // }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsMetersObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsMetersObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      // if (!this.dsMetersObj.ammeterType || !this.dsMetersObj.sectionNoteEE) {
      if (!this.dsMetersObj.sectionNoteEE) {
        return false;
      }
      // if (this.dsMetersObj.ammeterTypeApplicable && !this.dsMetersObj.ammeterDisplay) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsMetersObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsMetersObj.sectionNoteME) return false;
    }
    return true;
  }

}

